module.exports = __webpack_public_path__ + "onboarding-sidebar-good.9b3be7a54b7a4e419022873de3d3d5a7.hashedasset.png";